import { Block } from 'types/page';
import { DraftInlineStyleType } from 'draft-js'

const block = (children: Block[], color = '#ffffff'): Block => (
  {
    "id": 16,
    "type": "Background",
    "style": "",
    "color": color,
    "children": [
      {
        "id": 27,
        "type": "Column",
        "style": "max-width: 1080px; margin: auto; padding: 20px;",
        "styleMobile": "max-width: 1080px; margin: auto; padding: 20px;",
        "isSelectable": false,
        "children": [
          ...children
        ]
      }
    ],
  }
);

const bullet = (text: string, field: string, params: Params): Block => ({
    "id": 15,
    "type": "Text",
    "style": "margin-top:0px",
    "children": [],
    "aiField": field,
    "text": {
      "value": {
        "blocks": [
          {
            "key": "886ni",
            "text": `✓ ${text}`,
            "type": "align-left-item",
            "depth": 0,
            "inlineStyleRanges": [
              {
                "offset": 0,
                "length": text.length + 2,
                "style": params.textFont as DraftInlineStyleType
              },
              {
                "offset": 0,
                "length": 1,
                "style": "color-#1ca4fc" as DraftInlineStyleType
              },
              {
                "offset": 0,
                "length": 1,
                "style": "BOLD"
              },
              {
                "offset": 0,
                "length": 1,
                "style": "size-40px" as DraftInlineStyleType
              },
              {
                "offset": 1,
                "length": text.length + 1,
                "style": `color-${params.textColor}` as DraftInlineStyleType
              },
              {
                "offset": 1,
                "length": text.length + 1,
                "style": "size-20px" as DraftInlineStyleType
              }
            ],
            "entityRanges": [],
            "data": {}
          },
        ],
        "entityMap": {}
      },
    }
  })

  const titleBlock = (text: string, field: string, params: Params): Block => ({
    "id": 15,
    "type": "Text",
    "style": "margin-top:0px",
    "children": [],
    "aiField": field,
    "text": {
      "value": {
        "blocks": [
          {
            "key": "886ni",
            "text": text,
            "type": "align-center-item",
            "depth": 0,
            "inlineStyleRanges": [
              {
                "offset": 0,
                "length": text.length,
                "style": "size-Huge" as DraftInlineStyleType
              },
              {
                "offset": 0,
                "length": text.length,
                "style": `color-${params.textColor}` as DraftInlineStyleType
              },
              {
                "offset": 0,
                "length": text.length,
                "style": params.headerFont as DraftInlineStyleType
              }
            ],
            "entityRanges": [],
            "data": {}
          }
        ],
        "entityMap": {}
      }
    }
  })


 interface Params {
   textColor?: string;
   bg?: string;
   headerFont: string;
   textFont: string;
 }


  export const createBulletBlock = (title: string, bullets: string[], params: Params): Block => {
    return block([
      titleBlock('\n'+title, 'bulletsPointsTitle', params),
      ...bullets.map((text, i) => bullet(text, `bulletsPoints`, params))
    ], params?.bg)
  }
